import { useRouter } from "next/router";
import _ from "lodash";

let debounceNewQueryValue = {};
const debounceQueryUpdate = _.debounce((routerNavigateFn, router) => {
    routerNavigateFn({
        pathname: router.pathname,
        query: debounceNewQueryValue,
    });
    debounceNewQueryValue = {};
}, 0);

export function useRouterQueryOld() {
    let router = useRouter();

    function updateQuery(changes, { merge = true, replace = true } = {}) {
        let newQuery = merge
            ? {
                  ...router.query,
                  ...changes,
              }
            : changes;
        newQuery = Object.fromEntries(Object.entries(newQuery).filter(([, v]) => v != null));
        let routerNavigateFn = replace ? router.replace : router.push;
        debounceNewQueryValue = _.merge(debounceNewQueryValue, newQuery);
        return debounceQueryUpdate(routerNavigateFn, router);
    }

    function clearQuery() {
        return router.replace(router.pathname, undefined, { shallow: true });
    }

    return { query: router.query, updateQuery, clearQuery };
}
